import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Публичные секции сайта
import Navbar from "./components/navbar/Navbar";
import Banner from "./components/banner/Banner";
import Services from "./components/services/Services";
import Doctors from "./components/doctors/Doctors";
import Facilities from "./components/facilities/Facilities";
import Gallery from "./components/gallery/gallery";
import Partnership from "./components/partnership/partnership";
import NewsCarousel from "./components/news/NewsCarousel";
import Footer from "./components/footer/Footer";

// Админка
import Login from "./admin/Login";
import ProtectedRoute from "./admin/auth/ProtectedRoute";
import AdminLayout from "./admin/AdminLayout";
import AdminHome from "./admin/pages/AdminHome";
import DoctorsAdmin from "./admin/pages/DoctorsAdmin";
import NewsAdmin from "./admin/pages/NewsAdmin";

import "./App.css";
import "./index.css";

// Главная (публичная) страница
function PublicSite() {
  return (
    <>
      <Navbar />
      <Banner />
      <Services />
      <Partnership />
      <Doctors />
      <Gallery />
      <Facilities />
      <NewsCarousel />
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Публичные */}
        <Route path="/" element={<PublicSite />} />

        {/* Логин в админку */}
        <Route path="/admin/login" element={<Login />} />

        {/* Защищённые админ-маршруты (ProtectedRoute ДОЛЖЕН рендерить <Outlet />) */}
        <Route element={<ProtectedRoute />}>
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminHome />} />
            <Route path="doctors" element={<DoctorsAdmin />} />
            <Route path="news" element={<NewsAdmin />} /> {/* страница новостей */}
          </Route>
        </Route>

        {/* 404 */}
        <Route path="*" element={<div style={{ padding: 20 }}>Страница не найдена</div>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
